export const mainSite = process.env.REACT_APP_MAINSITE;
export const backend = process.env.REACT_APP_BACKEND;